import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
	{
		key: "login",
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() => import("views/auth-views/authentication/login")),
	},
];

export const protectedRoutes = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		component: React.lazy(() => import("views/app-views/dashboard")),
	},
	{
		key: "lista-cliente",
		path: `${APP_PREFIX_PATH}/lista-cliente`,
		component: React.lazy(() => import("views/app-views/lista-cliente")),
	},
	{
		key: "editar-cliente",
		path: `${APP_PREFIX_PATH}/cliente/:id`,
		component: React.lazy(() => import("views/app-views/cliente")),
	},
	{
		key: "cadastro-cliente",
		path: `${APP_PREFIX_PATH}/cliente`,
		component: React.lazy(() => import("views/app-views/cliente")),
	},
	{
		key: "visualizar-cliente",
		path: `${APP_PREFIX_PATH}/visualizar-cliente/:id`,
		component: React.lazy(() => import("views/app-views/visualizar-cliente")),
	},
	{
		key: "financeiro",
		path: `${APP_PREFIX_PATH}/financeiro`,
		component: React.lazy(() => import("views/app-views/financeiro")),
	},
	{
		key: "cadastro-lista-categoria",
		path: `${APP_PREFIX_PATH}/cadastro/lista-categoria`,
		component: React.lazy(() => import("views/app-views/cadastros/lista-categoria")),
	},
	{
		key: "cadastro-editar-categoria",
		path: `${APP_PREFIX_PATH}/cadastro/categoria/:id`,
		component: React.lazy(() => import("views/app-views/cadastros/categoria")),
	},
	{
		key: "cadastro-cadastro-categoria",
		path: `${APP_PREFIX_PATH}/cadastro/categoria`,
		component: React.lazy(() => import("views/app-views/cadastros/categoria")),
	},
	{
		key: "cadastro-lista-fornecedor",
		path: `${APP_PREFIX_PATH}/cadastro/lista-fornecedor`,
		component: React.lazy(() => import("views/app-views/cadastros/lista-fornecedor")),
	},
	{
		key: "cadastro-editar-fornecedor",
		path: `${APP_PREFIX_PATH}/cadastro/fornecedor/:id`,
		component: React.lazy(() => import("views/app-views/cadastros/fornecedor")),
	},
	{
		key: "cadastro-cadastro-fornecedor",
		path: `${APP_PREFIX_PATH}/cadastro/fornecedor`,
		component: React.lazy(() => import("views/app-views/cadastros/fornecedor")),
	},
	{
		key: "cadastro-lista-forma-pagamento",
		path: `${APP_PREFIX_PATH}/cadastro/lista-forma-pagamento`,
		component: React.lazy(() => import("views/app-views/cadastros/lista-forma-pagamento")),
	},
	{
		key: "cadastro-editar-forma-pagamento",
		path: `${APP_PREFIX_PATH}/cadastro/forma-pagamento/:id`,
		component: React.lazy(() => import("views/app-views/cadastros/forma-pagamento")),
	},
	{
		key: "cadastro-cadastro-forma-pagamento",
		path: `${APP_PREFIX_PATH}/cadastro/forma-pagamento`,
		component: React.lazy(() => import("views/app-views/cadastros/forma-pagamento")),
	},
	{
		key: "cadastro-lista-produto",
		path: `${APP_PREFIX_PATH}/cadastro/lista-produto`,
		component: React.lazy(() => import("views/app-views/cadastros/lista-produto")),
	},
	{
		key: "cadastro-editar-produto",
		path: `${APP_PREFIX_PATH}/cadastro/produto/:id`,
		component: React.lazy(() => import("views/app-views/cadastros/produto")),
	},
	{
		key: "cadastro-cadastro-produto",
		path: `${APP_PREFIX_PATH}/cadastro/produto`,
		component: React.lazy(() => import("views/app-views/cadastros/produto")),
	},
	{
		key: "cadastro-lista-usuario",
		path: `${APP_PREFIX_PATH}/cadastro/lista-usuario`,
		component: React.lazy(() => import("views/app-views/cadastros/lista-usuario")),
	},
	{
		key: "cadastro-cadastro-usuario",
		path: `${APP_PREFIX_PATH}/cadastro/usuario`,
		component: React.lazy(() => import("views/app-views/cadastros/usuario")),
	},
];
